import api from 'atg/api/API';
import * as types from 'atg/redux/actionTypes';
import { showLockedAlertDialog as showSharedLockedAlertDialog } from 'shared/redux/actions';

export const changeView = (viewInstance, viewType, hasToolbar = false) => {
  if (viewInstance.setup) {
    viewInstance.setup();
  }

  return {
    type: types.CHANGE_VIEW,
    payload: {
      viewInstance,
      hasToolbar,
      viewType,
    },
  };
};

export const showLockedAlertDialog = () =>
  showSharedLockedAlertDialog(api.betInformation.getBetConfig().isShared());
